import { useQuery } from '@tanstack/react-query';
import { fetchSiteTags, type AnalyticsTag } from '@apis/analytics';

/**
 * Read the site's analytics tag roster. Server resolves display names and
 * sorts alphabetically — FE does not re-sort. Cache is keyed by site so
 * navigating between sites doesn't reuse stale rosters.
 */
export function useSiteTags(siteId: string | null | undefined) {
  return useQuery<AnalyticsTag[]>({
    queryKey: ['site', 'tags', siteId],
    queryFn: ({ signal }) => fetchSiteTags(siteId!, signal),
    enabled: !!siteId,
    staleTime: 5 * 60 * 1000,
    refetchOnWindowFocus: false,
  });
}
